import React from 'react';
import { CheckCircleFilledIcon } from '@stashinvest/react-assets';
import { Text } from '@stashinvest/react-components';

export type StepChecklistItem = {
	title: string;
	detail?: string;
	complete?: boolean;
	muted?: boolean;
};

function StepMarker({ complete = false }: { complete?: boolean }) {
	if (complete) {
		return (
			<CheckCircleFilledIcon
				aria-hidden="true"
				className="!h-[26px] !w-[26px] text-primary"
				size="small"
			/>
		);
	}

	return (
		<span
			aria-hidden="true"
			className="cornerRadiusFull mt-[3px] h-[20px] w-[20px] border-[1px] border-solid border-outlineVariant bg-containerLowest"
		/>
	);
}

export function StepChecklist({ steps }: { steps: StepChecklistItem[] }) {
	return (
		<>
			{steps.map((step, index) => (
				<div key={step.title} className="grid grid-cols-[26px_1fr] gap-x-contentXS">
					<div className="flex flex-col items-center">
						<StepMarker complete={step.complete} />
						{index < steps.length - 1 && (
							<span className="my-[2px] h-[30px] border-l-[1px] border-solid border-outlineVariant" />
						)}
					</div>
					<div className={step.muted ? 'opacity-80' : undefined}>
						<Text tag="p" textStyle="bodyMediumEmphasize" className="text-onSurface">
							{step.title}
						</Text>
						{step.detail && (
							<Text tag="p" textStyle="bodySmallStandard" className="text-onSurface">
								{step.detail}
							</Text>
						)}
					</div>
				</div>
			))}
		</>
	);
}
